import { Component, h, Prop, State} from '@stencil/core';
import logout from '../../services/logout';

@Component({
  tag: 'mobile-header-nav',
  styleUrl: 'mobile-header-nav.scss',
  shadow: true,
})



export class MobileHeaderNav {

  /**
  * The dev env
  */
  @Prop() env?: string = 'https://www.brighttalk.com';

  // User State
  @Prop() isLoggedIn: boolean = false;
  @Prop() isManager: boolean = false;
  @Prop() isChannelOwner: boolean = false;
  @Prop() isPreAuthenticated: boolean = false;

  // This will add a redirect param to the end of the login url
  @Prop() loginRedirect?: string = '/login';

  async logoutBtn(e) {
    e.preventDefault();
    await logout(this.env);
  }

  @State() mobileSubmenu_browser?: boolean = false;
  @State() mobileSubmenu_account?: boolean = false;
  @State() mobileSubmenu_watch?: boolean = false;

  private toggleMobileSubmenuBrowser = () => {
  this.mobileSubmenu_browser = !this.mobileSubmenu_browser;
  }
  private toggleMobileSubmenuWatch = () => {
    this.mobileSubmenu_watch = !this.mobileSubmenu_watch;
  }

  private toggleMobileSubmenuAccount = () => {
  this.mobileSubmenu_account = !this.mobileSubmenu_account;
  }

  myAccount(){
  return <div>
    <ul id="menu-header" class="btalk-nav max width">
      <li class="menu-item menu-item-has-children">
        <button type="button" class={{'parent-link': true, in: this.mobileSubmenu_watch}} onClick={() => this.toggleMobileSubmenuWatch()}>
          <span>Watch</span>
          <div class="btalk-sub-toggle" data-toggle="collapse" data-target="sub-menu.sm-0">
            <span aria-hidden="true"><i class="fa-regular fa-angle-down"></i></span>
          </div>
        </button>
        <ul class="sub-menu">
          <li>
            <a class="menu-item" href={this.env +`/all-talks`}>
              Talks
            </a>
            </li>
            <li>
            <a class="menu-item" href={this.env +`/summits`}>
              Summits
            </a>
            </li>
            <li>
            <a class="menu-item" href={this.env +`/series`}>
              Series
            </a>
          </li>
        </ul>
      </li>

      <li class="menu-item menu-item-has-children">
        <button type="button" class={{'parent-link': true, in: this.mobileSubmenu_browser}} onClick={() => this.toggleMobileSubmenuBrowser()}>
        <span>Browse</span>
        <div class="btalk-sub-toggle" data-toggle="collapse" data-target="sub-menu.sm-0">
          <span aria-hidden="true"><i class="fa-regular fa-angle-down"></i></span>
        </div>
        </button>
        <ul class="sub-menu">
          <li>
            <a class="menu-item" href={this.env +`/topics`}>
              Topics
            </a>
          </li>
          <li>
            <a class="menu-item" href={this.env +`/channels`}>
              Channels
            </a>
          </li>
        </ul>

      </li>
      <li class="my-account menu-item menu-item-has-children">
        <button type="button" class={{'parent-link': true, in: this.mobileSubmenu_account}} onClick={() => this.toggleMobileSubmenuAccount()}>
        <span>My account</span>
        <div class="btalk-sub-toggle" data-toggle="collapse" data-target="sub-menu.sm-0">
          <span aria-hidden="true"><i class="fa-regular fa-angle-down"></i></span>
        </div>
        </button>
              <ul class="sub-menu">
                {this.isManager && !this.isPreAuthenticated ? (
                  <li class="menu-item">
                    <a class="menu-item" href={this.env + `/central/manage/channels/`}>
                      Manage
                    </a>
                  </li>
                ) : (
                  ''
                )}
                <li class="menu-item">
                  <a class="menu-item" href={this.env +`/mybrighttalk/my-feed/`}>
                    My feed
                  </a>
                </li>
                <li class="menu-item">
                  <a class="menu-item" href={this.env +`/mybrighttalk/watch-later/`}>
                    Watch later
                  </a>
                </li>
                <li class="menu-item">
                  <a class="menu-item" href={this.env +`/mybrighttalk/recently-viewed/`}>
                    Recently viewed
                  </a>
                </li>
                <li class="menu-item">
                  <a class="menu-item" href={this.env +`/mybrighttalk/channels/`}>
                    My channels
                  </a>
                </li>
                {!this.isPreAuthenticated &&
                  <li class="menu-item">
                    <a class="menu-item" href={this.env +`/mybrighttalk/settings/profile/`}>
                      Account settings
                    </a>
                  </li>
                }
                <li class="menu-item">
                  <a class="menu-item" href="/logout" onClick={e => this.logoutBtn(e)}>
                    Log out
                  </a>
                </li>
              </ul>
      </li>
    </ul>
    <ul id="menu-header-foot" class="btalk-nav max width">
      <li class="menu-item">
        <a href={this.env + `/presenting`} rel="nofollow" target='_blank'>
          Presenter access
        </a>
      </li>
      <li class="menu-item">
        <a href={this.env + `/business/`} rel="follow" target='_blank'>
          BrightTALK for business
        </a>
      </li>
      <li class="menu-item">
        <a href={this.env + `/central/`} rel="nofollow" target='_blank'>
          BrightTALK Central
        </a>
      </li>
    </ul>
  </div>;
  }

  loginJoin(){
  return <div>
    <ul id="menu-header" class="btalk-nav max width">
      <li class="menu-item">
        <button type="button" class={{'parent-link': true, in: this.mobileSubmenu_watch}} onClick={() => this.toggleMobileSubmenuWatch()}>
          <span>Watch</span>
          <div class="btalk-sub-toggle" data-toggle="collapse" data-target="sub-menu.sm-0">
            <span aria-hidden="true"><i class="fa-regular fa-angle-down"></i></span>
          </div>
        </button>
        <ul class="sub-menu">
          <li>
            <a class="menu-item" href={this.env +`/all-talks`}>
              Talks
            </a>
            </li>
            <li>
            <a class="menu-item" href={this.env +`/summits`}>
              Summits
            </a>
            </li>
            <li>
            <a class="menu-item" href={this.env +`/series`}>
              Series
            </a>
          </li>
        </ul>
      </li>

      <li class="menu-item menu-item-has-children">
        <button type="button" class={{'parent-link': true, in: this.mobileSubmenu_browser}} onClick={() => this.toggleMobileSubmenuBrowser()}>
        <span>Browse</span>
        <div class="btalk-sub-toggle" data-toggle="collapse" data-target="sub-menu.sm-0">
          <span aria-hidden="true"><i class="fa-regular fa-angle-down"></i></span>
        </div>
        </button>
        <ul class="sub-menu">
          <li>
            <a class="menu-item" href={this.env +`/topics`}>
              Topics
            </a>
          </li>
          <li>
            <a class="menu-item" href={this.env +`/channels`}>
              Channels
            </a>
          </li>
        </ul>

      </li>

      <li class="menu-item">
        <a class="" href={this.env + this.loginRedirect} rel="nofollow">
          <span>Log in</span>
        </a>
      </li>

      <li class="menu-item btl-out btl-join btalk-join">
        <a class="" href={this.env + `/join/`}>
          <span>Join now</span>
        </a>
      </li>
    </ul>
    <ul id="menu-header-foot" class="btalk-nav max width">
      <li class="menu-item">
        <a href={this.env + `/presenting`} rel="nofollow" target='_blank'>
          Presenter access
        </a>
      </li>
      <li class="menu-item">
        <a href={this.env + `/business/`} rel="follow" target='_blank'>
          BrightTALK for business
        </a>
      </li>
      <li class="menu-item">
        <a href={this.env + `/central/`} rel="nofollow" target='_blank'>
          BrightTALK Central
        </a>
      </li>
    </ul>
  </div>
  }


 render() {

  return (
    <nav class="btalk-nav-wrap mobile">
    {this.isLoggedIn ? this.myAccount() : this.loginJoin() }
    </nav>
  );
 }
}
